var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-overlay',{attrs:{"value":_vm.loading,"absolute":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary"}})],1),(!_vm.loading)?_c('div',[_c('app-form',{attrs:{"parentObject":{
        data: this.formData,
        id: this.id,
        pageTitle: this.pageTitle,
        pageTitleValue: this.pageTitleValue,
        commonKpiList: this.commonKpiList,
        loadingCommonKpi: this.loadingCommonKpi,
        errMsg: this.errMsg,
        isEdit: this.editMode,
        isWizard: this.wizardMode,
      }},on:{"input":function($event){_vm.formData = $event},"cancel":_vm.cancelHandler,"save":_vm.saveHandler,"error":_vm.errorHandler,"reload":_vm.loadKpiCommonListHandler}}),(_vm.isErr)?_c('div',[_c('app-error',{attrs:{"parentError":{
          data: this.errMsg,
          isErr: this.isErr,
        }},on:{"closeError":function($event){_vm.isErr = $event}}})],1):_vm._e()],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }